import Environment from '@interfaces/environment.interface'
import Gamification from '@interfaces/gamification.interface'
import Ranking from '@interfaces/ranking.interface'
import onEnvironmentChange from '@observables/environment.observable'
import LogService from '@services/log/log.service'
import MainService from '@services/main/main.service'
import { AxiosResponse } from 'axios'
import { take } from 'rxjs/operators'

export default class LexLuthorService extends MainService {
  url: string
  logService = new LogService()

  constructor(lexLuthorUrl?: string) {
    super()
    if (!lexLuthorUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.lexLuthor
      })
    } else {
      this.url = lexLuthorUrl
    }
    this.logService.init('Lex Luthor Service')
  }

  public async getRankings(idCampaign: string, username?: string, page = 1, limit = 100): Promise<{ data: Ranking[]; total: number }> {
    if (!idCampaign) {
      throw new Error('idCampaign is required')
    }
    const headers = await this.getHeaders()
    return this.http
      .get(
        `${this.url}/hub/gamifications/${idCampaign}/ranking?limit=${limit}&${
          username ? `name=${username}&` : ''
        }sort=position&order=1&page=${page}`,
        {
          headers,
        }
      )
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on rankings to campaign ' + idCampaign,
          error,
        })
        throw error.response
      })
  }

  public async getGamifications(idCampaign: string): Promise<Gamification[]> {
    if (!idCampaign) {
      throw new Error('idCampaign is required')
    }
    const headers = await this.getHeaders()
    return this.http
      .get(`${this.url}/hub/gamifications/campaign/${idCampaign}`, {
        headers,
      })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on get gamification ' + idCampaign,
          error,
        })
        throw error.response
      })
  }

  public async getSocialNetworksConfig(): Promise<any> {
    const headers = await this.getHeaders()
    return this.http
      .get(`${this.url}/hub/gamifications/socialnetworks`, {
        headers,
      })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on get social networks config',
          error,
        })
        throw error.response
      })
  }

  public async getRankingsHistory(idCampaign: string, userId?: string): Promise<Ranking[]> {
    if (!idCampaign) {
      throw new Error('idCampaign is required')
    }
    if (!userId) {
      throw new Error('userId is required')
    }
    const headers = await this.getHeaders()
    return this.http
      .get(`${this.url}/hub/gamifications/${idCampaign}/users/${userId}/ranking`, {
        headers,
      })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on rankings history to campaign ' + idCampaign,
          error,
        })
        throw error.response
      })
  }
}
